import numberFormatMixin from './../../mixins/numberFormat';

export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
    translation: {
      type: String,
      required: false,
    },
    noDataMessage: {
      type: String,
      required: false,
    },
    link: {
      type: Function,
      required: false,
    },
    linkKey: {
      type: String,
      required: false,
    },
    rowKey: {
      type: String,
      required: false,
    },
    buttons: {
      type: Array,
      required: false,
    },
    expandableKey: {
      type: String,
      required: false,
    },
    expandableRows: {
      type: String,
      required: false,
    },
  },

  methods: {
    html(data, key) {
      return this.numberFormat(data, key);
    },

    inArray(needle, haystack) {
      if (haystack !== undefined) {
        var arr = haystack.split(',');
      } else {
        var arr = new Array();
      }

      for (const i in arr) {
        if (arr[i] == needle) return true;
      }
      return false;
    },
    convertToArray(s) {
      if (s !== undefined) {
        return s.split(',');
      }
      return [];
    },
  },

  mixins: [
    numberFormatMixin,
  ],
};



// WEBPACK FOOTER //
// ./src/app/components/table/table.js